exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-state-legend[data-v-00e0d9c8]{display:inline-flex;align-items:center;gap:4px;font-size:12px;font-weight:400;color:#4e5560}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-00e0d9c8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/pi/piStateLegend.vue
// module id = 1662
// module chunks = 0